<!-- a card for each type: its icon, how many there are and its name; choosing one goes to its section -->
<div class="numbers" role="group" aria-label="Node numbers">
    @for (d of data; track d.name) {
        @if (canSelect) {
            <button type="button" class="number-card selectable" [class.selected]="selected === d.type" (click)="selectType(d.type)" [title]="'Go to ' + d.name">
                <span class="icon"><app-node-svg [type]="d.type" [noText]="true" [height]="30"/></span>
                <span class="text"><span class="number">{{d.number | number}}</span><span class="name">{{d.name}}</span></span>
            </button>
        } @else {
            <div class="number-card">
                <span class="icon"><app-node-svg [type]="d.type" [noText]="true" [height]="30"/></span>
                <span class="text"><span class="number">{{d.number | number}}</span><span class="name">{{d.name}}</span></span>
            </div>
        }
    }
</div>
